module.exports = __webpack_public_path__ + "static/media/small_logo.abccab6d.png";